import {propColor} from 'utils/Helper';

export default theme => ({
  root: {
    fontSize: 14,
    marginLeft: props => props.marginLeft || 5,
    marginRight: props => props.marginRight || 5,
    top: 3,
    position: 'relative',
    color: propColor('color', '#888'),
  }
});

